import $ from 'jquery';

export default function relatedActionsLink() {
    $('.related-actions-link').on('click', function(e) {
        var $relatedActionsSel = $(this).next('.related-actions');

        $relatedActionsSel.toggle();

        if ($relatedActionsSel.hasClass('related-actions-show')) {
            $relatedActionsSel.removeClass('related-actions-show');
        } else {
            $relatedActionsSel.addClass('related-actions-show');
        }
        e.preventDefault();
    });
}
